'use strict';

import Notifications from './stores/notifications';
import Roles from './stores/roles';
import Titles from './stores/titles';
import Genders from './stores/genders';
import SecurityQuestions from './stores/security-questions';
import ContactMethods from './stores/contact-methods';
import ContactTimes from './stores/contact-times';
import VehicleGroups from './stores/vehicle-groups';
import VehicleMakes from './stores/vehicle-makes';
import VehicleTransmissions from './stores/vehicle-transmissions';
import VehicleTypes from './stores/vehicle-types';
import LicenceAuthorities from './stores/licence-authorities';
import VehicleUseTypes from './stores/vehicle-use-types';
import Insurers from './stores/insurers';
import CoverLevels from './stores/cover-levels';
import LetterHeads from './stores/letter-heads';
import Incident from './stores/incident';
import IncidentClaimTypes from './stores/incident-claim-types';
import Services from './stores/services';
import Tariffs from './stores/tariffs';
import DriverTypes from './stores/driver-types';
import CreditHireCharges from './stores/credit-hire-charges';
import CreditHireChargeTypes from './stores/credit-hire-charge-types';
import DocumentTypes from './stores/document-types';
import HireSites from './stores/hire-sites';
import Companies from './stores/companies';
import CompanyTypes from './stores/company-types';
import RateGroups from './stores/rate-groups';
import HoldBackReasons from './stores/hold-back-reasons';
import ShortFallReasons from './stores/short-fall-reasons';
import DebtRecoveryStatuses from './stores/debt-recovery-statuses';
import ClaimRoutes from './stores/claim-routes';
import ClaimHandlers from './stores/claim-handlers';
import InvoiceRecipients from './stores/invoice-recipients';
import IncidentStatus from './stores/incident-status';
import QualificationQuestions from './stores/qualification-questions';
import DebtRecovery from './stores/debt-recovery';
import SalvageNonRetentionReasons from './stores/salvage-non-retention-reasons';
import LiabilityTypes from './stores/liability-types';
import LiabilityStatuses from './stores/liability-statuses';
import LiabilityStances from './stores/liability-stances';
import IncidentCategories from './stores/incident-categories';
import VehicleStatuses from './stores/vehicle-statuses';
import Penalties from './stores/penalties';
import VehicleExtras from './stores/vehicle-extras';
import DefleetReasons from './stores/defleet-reasons';
import JobTypes from './stores/job-types';
import StatementTypes from './stores/statement-types';
import TheftStatuses from './stores/theft-statuses';
import VulnerabilityCodes from './stores/vulnerability-codes';
import VulnerabilityConsentMethods from './stores/vulnerability-consent-methods';
import Recharges from './stores/recharges';

export default {
  state: {
    user: {},
    hideSidebar: false,
    listener: false
  },
  mutations: {
    enableListener(state) {
      state.listener = true;
    },
    setUser(state, user) {
      state.user = user;
    },
    toggleSidebar(state, value) {
      state.hideSidebar = value;
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    agent(state) {
      if (state.user.tenant && state.user.tenant.agent) {
        return state.user.tenant.agent;
      }

      return null;
    },

    isSidebarVisible(state) {
      return !state.hideSidebar;
    },

    superAdmin(state) {
      return state.user.tenant_id > 0;
    }
  },

  modules: {
    Notifications,
    Roles,
    Titles,
    Genders,
    SecurityQuestions,
    ContactMethods,
    ContactTimes,
    VehicleGroups,
    VehicleMakes,
    VehicleTransmissions,
    Insurers,
    LetterHeads,
    CoverLevels,
    Incident,
    LicenceAuthorities,
    VehicleTypes,
    VehicleUseTypes,
    IncidentClaimTypes,
    Services,
    Tariffs,
    DriverTypes,
    CreditHireCharges,
    CreditHireChargeTypes,
    DocumentTypes,
    HireSites,
    Companies,
    CompanyTypes,
    RateGroups,
    HoldBackReasons,
    ShortFallReasons,
    DebtRecoveryStatuses,
    ClaimRoutes,
    ClaimHandlers,
    InvoiceRecipients,
    IncidentStatus,
    QualificationQuestions,
    DebtRecovery,
    SalvageNonRetentionReasons,
    LiabilityTypes,
    VehicleStatuses,
    Penalties,
    VehicleExtras,
    DefleetReasons,
    LiabilityStatuses,
    LiabilityStances,
    TheftStatuses,
    JobTypes,
    IncidentCategories,
    VulnerabilityCodes,
    VulnerabilityConsentMethods,
    Recharges,
    StatementTypes
  }
};
